import { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { type UsersEventsPage, type UsersEventsSortBy } from '../models/engagement-users'
import { GetUsersEventsQuery } from '../../data/queries/get-users-events.query'
import { type UsersEventsPageEntity } from '../../data/entities/users.entity'

export interface GetUsersEventsParams {
  fromDate: string
  toDate: string
  fromPrevious: string
  toPrevious: string
  sortBy: UsersEventsSortBy
  sortOrder: 'asc' | 'desc'
  offset: number
  limit: number
  organization: string
}

export class GetUsersEventsInteractor {
  constructor(private readonly repository: GetInteractor<UsersEventsPageEntity>) {}

  public async execute(params: GetUsersEventsParams): Promise<UsersEventsPage> {
    return await this.repository.execute(
      new GetUsersEventsQuery(
        params.fromDate,
        params.toDate,
        params.fromPrevious,
        params.toPrevious,
        params.sortBy,
        params.sortOrder,
        params.offset,
        params.limit,
        params.organization
      )
    )
  }
}
